"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.saveState = saveState;
exports.getSavedState = getSavedState;
exports.clearSavedState = clearSavedState;
function saveState(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
}

function getSavedState(key) {
    var savedState = localStorage.getItem(key);

    return savedState ? JSON.parse(savedState) : null;
}

function clearSavedState(key) {
    localStorage.removeItem(key);
}